<div class="container-fluid">
    <div class="row">
        <div class="text-center col-12">© {{ currentYear }} {{ appName }} By <span
            class="fw-semibold">{{ credits.name }}</span></div>
    </div>
</div>
